import Head from "../../components/Head";
import background from "../../images/services_background.png";
import classes from "../../components/Services.module.css";
import Button from "../../components/Button";
import ContentBelow from "../../components/ContentBelow";
import RAFAdvance from "../../components/Forms/RAF-Advance";

function LayoutPage({ children, Form, heading, backgroundImage }) {
  return (
    <>
      {heading ? (
        <Head imageUrl={backgroundImage ? backgroundImage : background}>
          <h2 className="heading_space">{heading}</h2>
        </Head>
      ) : null}

      <ContentBelow>
        <div
          className="container m-0 mx-auto  p-1"
          style={{ borderRadius: "0%" }}
        >
          {children}
        </div>
        <div className=" container-fluid col-sm-10 col-lg-6 col-md-9 p-2 text-light">
          {Form}
        </div>
      </ContentBelow>
    </>
  );
}

export default LayoutPage;
